function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

export function delay() {
  var ms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve(undefined);
    }, ms);
  });
}
export function isJSON(str) {
  try {
    var obj = JSON.parse(str);

    if (obj && _typeof(obj) === "object" && obj !== null) {
      return true;
    }
  } catch (err) {// NOTHING
  }

  return false;
}
export var getValue = function getValue(func, defaultValue) {
  try {
    return func();
  } catch (error) {
    return defaultValue;
  }
};